var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-fab md-primary",attrs:{"to":"/delete"}},[_c('md-icon',[_vm._v("delete")]),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("delete documentation")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }